var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSparkles = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5C15.5 6.5 15 4 16 4C17 4 16.5 6.5 18.5 8.5C20.5 10.5 23 10 23 11C23 12 20.5 11.5 18.5 13.5C16.5 15.5 17 18 16 18C15 18 15.5 15.5 13.5 13.5C11.5 11.5 9 12 9 11C9 10 11.5 10.5 13.5 8.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 3.35C8.43223 4.13223 10 4 10 4.5C10 5 8.45706 4.84294 7.65 5.65C6.84294 6.45706 7 8 6.5 8C6 8 6.16247 6.46246 5.35 5.65C4.53753 4.83754 3 5 3 4.5C3 4 4.51237 4.18763 5.35 3.35C6.18763 2.51237 6 1 6.5 1C7 1 6.86777 2.56777 7.65 3.35Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17C8 18 10 17.7885 10 18.5C10 19.2115 8 19 7 20C6 21 6.23648 23 5.5 23C4.76352 23 5 21 4 20C3 19 1 19.2707 1 18.5C1 17.7293 3 18 4 17C5 16 4.75168 14 5.5 14C6.24832 14 6 16 7 17Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSparkles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconSparkles.b44fee68aaf58e660c06425d0ddcf95c.svg";